import { Component, Inject, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Page } from '../../models/static-page/page-model';
import { PageService } from '../../services/static-page/page.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { BootstrapOptions } from '@angular/core/src/application_ref';
import { find } from 'rxjs/operator/find';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { CategoryService } from '../../services/category/category.service';

@Component({
    selector: 'app-page-list',
    templateUrl: './page-list.component.html',
    styleUrls: ['./page-list.component.css']
})
/** page-list component*/
export class PageListComponent {
  /** page-list ctor */
  public pageList: Page[];
  public searchKeyword: string;
  public pageStatus: string;
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  isActive: string;
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  public websiteName: string;
  constructor(private readonly pageService: PageService, private readonly utilitiesService: UtilitiesService,
    public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router,
    private readonly rolePermissionService: RolePermissionService, private readonly categoryService: CategoryService) {
    this.rolePermissionService.GetRolePermissions("staticpage").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          this.toastr.setRootViewContainerRef(vcr);
          this.GetPageList();
            this.pageStatus = "";
            this.GetSystemSettingFirstOrDefault();
          this.GetRowsPerPageList();
            this.isActive = "";
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
   
  }
  GetPageList() {
    this.pageService.getPages().subscribe(
      data => {
        this.pageList = data;

        this.filteredItems = data;
      }
    )
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  deletePage(id) {
    if (confirm("Are you sure to delete this static page?")) {
      this.pageService.deletePage(id).subscribe(
        response => {
          if (response) {
            this.toastr.success('Static Page has been Deleted.', 'Success');
            setTimeout(() => {
              this.GetPageList();
            }, 2000);
          }
          else {
            this.toastr.error('Error occurred. Please try again', 'Error');
          }
        }
      )
    }
  }
  OnFilterChange() {
    this.filteredItems = this.pageList;
    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }
    if (this.isActive == "true") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == true);

    }
    else if (this.isActive == "false") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == false);
    }
    if (this.pageStatus == "Pending" || this.pageStatus == "Draft" || this.pageStatus == "Published") {
      this.filteredItems = this.filteredItems.filter(s => s.pageStatus == this.pageStatus);

    }


  }
  GetSystemSettingFirstOrDefault() {
    this.categoryService.GetSystemSettingFirstOrDefault().subscribe(
      data => {
        this.websiteName = data.siteUrl + "/about/";
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/static-page/page-list/page-list.component.ts